// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_1j3zZ","popover":"_25aJM","disabled":"_2S7pF","label":"_18DTx","slider":"_1BfcP"};